import React from 'react';

const GPUBrowserHeader = ({ title, onToggleFilters }) => {
    return (
        <header className="flex items-center justify-between mb-4">
            <h1 className="text-3xl font-bold">{title}</h1>
            <button
                className="lg:hidden p-2 border rounded text-gray-700"
                onClick={onToggleFilters}
                aria-label="Open filters"
            >
                Filter and sort
            </button>
        </header>
    );
};

export default GPUBrowserHeader;
